import React from "react";
import { Grid, Divider, Typography, Box } from "@material-ui/core";
import {
  MasterButton,
  InputOptionMaster,
  InputTextMaster,
  InputReactDatepicker,
  ModalExportList,
} from "App/Component/ui";
import { getByFilterKunjunganIgdExport, valueTypeSearch } from ".";
import {
  defaultToastError,
  defaultToastSuccess,
  isNull,
} from "App/utils/helpers";
import { useState } from "react";
import { useSelector } from "react-redux";
export default function FormFilterKunjunganIgd(props) {
  const {
    formFilter,
    setFormFilter,
    setNewData,
    countHarian = 0,
    withExportButton = false,
    resetPagination,
  } = props;

  const [isLoading, setIsLoading] = useState(false);
  const [showModalExportList, setShowModalExportList] = useState(false);

  const handleChange = (text) => (e) => {
    setFormFilter((prev) => {
      return {
        ...prev,
        [text]: e.target.value,
        qword:
          text === "type_search" && e.target.value == 0
            ? ""
            : text === "qword"
            ? e.target.value
            : prev.qword,
      };
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    await setNewData(1, 10);
    resetPagination();
  };

  const master = useSelector(({ master }) => master);

  const handleExport = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      const res = await getByFilterKunjunganIgdExport(formFilter);
      if (res.state) {
        defaultToastSuccess(
          "Berhasil, mohon menunggu data sedang dieksport..."
        );
      } else {
        defaultToastError(res.message);
      }

      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      defaultToastError(error?.response?.data?.message);
    }
  };

  return (
    <>
      <form onSubmit={(e) => handleSubmit(e)}>
        <Grid container spacing={1}>
          <Grid item sm={3}>
            <InputOptionMaster
              name="type_search"
              label="KATEGORI PENCARIAN"
              id="type_search"
              withSearch={false}
              value={formFilter.type_search}
              onChange={handleChange("type_search")}
              data={valueTypeSearch}
            />
          </Grid>
          <Grid item sm={3}>
            <InputTextMaster
              name="name"
              label="KATA KUNCI"
              value={formFilter.qword}
              id="name"
              disabled={
                formFilter.type_search === 0 || formFilter.type_search === "0"
                  ? true
                  : false
              }
              onChange={handleChange("qword")}
              placeholder="Kata Kunci Sesuai Kategori"
            />
          </Grid>
          <Grid item sm={3}>
            <InputReactDatepicker
              selected={formFilter.first_date}
              label="TANGGAL AWAL"
              dateFormat="dd/MM/yyyy HH:mm"
              timeFormat="HH:mm"
              showTimeSelect
              timeIntervals={5}
              handleChangeToday={(e) =>
                setFormFilter({
                  ...formFilter,
                  first_date: e,
                })
              }
              onChange={(e) =>
                setFormFilter({
                  ...formFilter,
                  first_date: e,
                })
              }
            />
          </Grid>

          <Grid item sm={3}>
            <InputReactDatepicker
              selected={formFilter.finish_date}
              label="TANGGAL AKHIR"
              dateFormat="dd/MM/yyyy HH:mm"
              timeFormat="HH:mm"
              showTimeSelect
              timeIntervals={5}
              handleChangeToday={(e) =>
                setFormFilter({
                  ...formFilter,
                  finish_date: e,
                })
              }
              onChange={(e) =>
                setFormFilter({
                  ...formFilter,
                  finish_date: e,
                })
              }
            />
          </Grid>
          <Grid item sm={3}>
            <InputOptionMaster
              name="doctor"
              label="DOKTER"
              id="doctor"
              withSearch={true}
              data={master.dokter.list_select_name}
              labelValue={formFilter.doctor_name}
              value={formFilter.doctor}
              onChange={(e) => {
                if (isNull(e)) {
                  setFormFilter({
                    ...formFilter,
                    doctor: null,
                    doctor_name: "Pilih Dokter",
                  });
                } else {
                  setFormFilter({
                    ...formFilter,
                    doctor: e.value,
                    doctor_name: e.label,
                  });
                }
              }}
            />
          </Grid>
          <Grid item sm={3}>
            <InputOptionMaster
              name="type_rm"
              label="TYPE RM"
              id="type_rm"
              withSearch={false}
              value={formFilter.type_rm}
              onChange={handleChange("type_rm")}
              data={[
                {
                  label: "Semua",
                  value: 0,
                },
                {
                  label: "RM INTERNAL",
                  value: 1,
                },
                {
                  label: "RM EXTERNAL",
                  value: 2,
                },
              ]}
            />
          </Grid>

          <Grid item sm={3}>
            <InputOptionMaster
              name="status_igd"
              label="STATUS"
              id="status_igd"
              withSearch={false}
              value={formFilter.status}
              onChange={handleChange("status")}
              data={[
                {
                  label: "Semua",
                  value: 0,
                },
                {
                  label: "AKTIF",
                  value: 1,
                },
                {
                  label: "TIDAK AKTIF",
                  value: 2,
                },
              ]}
            />
          </Grid>

          <Grid item sm={3}>
            <InputOptionMaster
              name="is_cancel_igd"
              label="BATAL"
              id="is_cancel_igd"
              withSearch={false}
              value={formFilter.is_cancel}
              onChange={handleChange("is_cancel")}
              data={[
                {
                  label: "Semua",
                  value: 0,
                },
                {
                  label: "TIDAK DIBATALKAN",
                  value: 1,
                },
                {
                  label: "BATAL",
                  value: 2,
                },
              ]}
            />
          </Grid>
        </Grid>
        <br />

        <div
          className="mt-1"
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography variant="body1" id="countHarian" component="div">
            Total kunjungan hari ini: {countHarian}
          </Typography>

          <Box sx={{ display: "flex", gap: "16px" }}>
            {withExportButton && (
              <>
                <MasterButton
                  type={"button"}
                  color="primary-cyan"
                  name={"Export List"}
                  size="md"
                  onClick={() => setShowModalExportList(!showModalExportList)}
                />
                <MasterButton
                  type={"button"}
                  color="warning"
                  name={isLoading ? "Loading..." : "EXPORT"}
                  disabled={isLoading}
                  size="md"
                  onClick={handleExport}
                />
              </>
            )}
            <MasterButton
              name={"CARI"}
              type="submit"
              outline={true}
              color={"green"}
              size={"md"}
            />
          </Box>
        </div>

        <br />
        <Divider />
      </form>

      {showModalExportList && (
        <ModalExportList
          title={"Export List Kunjungan IGD"}
          showModal={() => setShowModalExportList(false)}
          type="regis_rigd"
        />
      )}
    </>
  );
}
